import { render } from "./FeaturedView.vue?vue&type=template&id=f2a80704&scoped=true&xmlns%3Acursor=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./FeaturedView.vue?vue&type=script&lang=js"
export * from "./FeaturedView.vue?vue&type=script&lang=js"

import "./FeaturedView.vue?vue&type=style&index=0&id=f2a80704&scoped=true&lang=css"

import exportComponent from "/home/PersonaExplorer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a80704"]])

export default __exports__